import { useState, useCallback } from "react";
import DriverDetail from "./DriverDetail";
import { useDispatch, useSelector } from "react-redux";
import { operations as customerMyOrderOperations } from "redux/CustomerMyOrder";
import navOperations from "redux/Navigation/operations";
import { formatPrice } from "utils";
import {CONSTANTS} from "client/utils/constants";
import { GetStatusIcon } from "client/utils/IconsUtil";

const DriverDetailContainer = (props: any) => {
  const [showDriverDetail, setShowDriverDetail] = useState(true);
  const handleClick = () => {
    setShowDriverDetail(false);
    dispatchActionColumn(true);
  };
  let growth: any[] = [];
  let planned: any[] = [];
  let unplanned: any[] = [];
  const dispatch = useDispatch();  
  const dispatchActionColumn =
    customerMyOrderOperations.dispatchActionColumn(dispatch);
  const [showEditPlannedPopup, setShowEditPlannedPopup] = useState(false);
  const [showEditUnPlannedPopup, setShowEditUnPlannedPopup] = useState(false);
  const [showEditGrowthPopup, setShowEditGrowthPopup] = useState(false);
  const [resetForm, setresetForm] = useState(false);
  const { orderDetails}: any = useSelector((state: any) => ({
    orderDetails: state.OrderReducer.orderByIdData,
  }));
  const hidePlannedPopup = () => {
    setShowEditPlannedPopup(false);
    setresetForm(false);
  };
  const ShowPlannedPopup = () => {
    setShowEditPlannedPopup(true);
    setresetForm(false);
  };
  const hideUnPlannedPopup = () => {
    setShowEditUnPlannedPopup(false);
    setresetForm(false);
  };
  const ShowUnPlannedPopup = () => {
    setShowEditUnPlannedPopup(true);
    setresetForm(false);
  };
  const hideGrowthdPopup = () => {
    setShowEditGrowthPopup(false);
    setresetForm(false);
  };
  const ShowGrowthPopup = () => {
    setShowEditGrowthPopup(true);
    setresetForm(false);
  };
  const resetOnclick = () => {
    setresetForm(true);
  };

  

  const activeRow = useSelector((state: any) => state.CustomerMyOrder.data);
  const onClickCancel = () => {
    setShowDriverDetail(true);
  };

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });


  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    []
  );
  const dispatchNav = navOperations.dispatchNav(dispatch);

  const popupOutlinebtnOnclick = (item: any) => {
    if (item !== "") {
      dispatchNav(item);
    }
    hideDialog();
  };

  orderDetails?.requests?.forEach((item: any, i: number) => {
    item?.reasons?.forEach((value: any, _index: number) => {
      if(value?.approximateDisposeValue !== null){
         value.approximateDisposeValue = '$' +  formatPrice(value?.approximateDisposeValue, 2)
      }
      if (value?.reasonType === CONSTANTS.REASON_GROWTH) {
        let growthArr = [...growth];
        if (growth[i]?.length > 0) growthArr[i] = [...growth[i], value];
        else growthArr[i] = [value];
        growth = [...growthArr];
      } else if (value?.reasonType === CONSTANTS.REASON_PLANNED) {
        let plannedArr = [...planned];
        if (planned[i]?.length > 0) plannedArr[i] = [...planned[i], value];
        else plannedArr[i] = [value];
        planned = [...plannedArr];
      } else if (value?.reasonType === CONSTANTS.REASON_UNPLANNED) {
        let unPlannedArr = [...unplanned];
        if (unplanned[i]?.length > 0)
          unPlannedArr[i] = [...unplanned[i], value];
        else unPlannedArr[i] = [value];
        unplanned = [...unPlannedArr];
      }
    });
  });
  const [selectedAttachments, setSelectedAttachments] = useState<any>([]);
  const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
  const [linkAttachmentId, setLinkAttachmentId] = useState();

  const onLinkAttachmentClicked = (i: any) => {
    const attachments = [...isAttachmentBtnClicked];
    attachments[i] = true;
    setIsAttachmentBtnClicked(attachments);
    setLinkAttachmentId(i);
  };

  const onLinkAttachmentClosed = (i: any) => {
    const attachments = [...isAttachmentBtnClicked];
    attachments[i] = false;
    setIsAttachmentBtnClicked(attachments);
    setLinkAttachmentId(i);
  };

  const iconReturn = (status: any) => {
    let src = GetStatusIcon(status)?.icon;
    return <img src={src} alt="statusIcon" className={status === "Fleet Processing" ? 'fleetprocessingicon statusIcon' : status === "Completed" ? 'completedicon statusIcon' : 'statusIcon'} />;
  };

  
  const Driverlableval = () => {
    if (orderDetails?.orderType == CONSTANTS.MANAGED_EQUIPMENT_REQUEST || orderDetails?.orderType == CONSTANTS.MANAGED_EQUIPMENT) {
      return "Model";
    } else if (orderDetails?.orderType == CONSTANTS.VEHICLE_REQUEST) {
      return "Drivers Title";
    }
  };
  const detailslableval = () => {
    if (orderDetails?.orderType == CONSTANTS.MANAGED_EQUIPMENT) {
      return "Year";
    } else if (orderDetails?.orderType == CONSTANTS.VEHICLE_REQUEST) {
      return "Drivers Details";
    }
  };
  const [showTooltip, setShowTooltip] = useState(false);
  const onDriverClick = () => {
    setShowTooltip(!showTooltip);
  };
  const getFormattedValue = (value :any) => {
    let newValue: any;
    if (Number.isInteger(value)) {
      newValue = value?.toLocaleString() + ".00";
    } else {
      newValue = value?.toLocaleString();
    }
    const valueArray = newValue.split(".");
    if (valueArray[1]?.length === 1) {
      return newValue + "0"
    } else {
      return newValue
    }
  }
 
  return (
    <DriverDetail
      onClickCancel={onClickCancel}
      activeRow={activeRow}
      growth={growth}
      planned={planned}
      unplanned={unplanned}
      showDriverDetail={showDriverDetail}
      handleClick={handleClick}
      hidePlannedPopup={hidePlannedPopup}
      ShowPlannedPopup={ShowPlannedPopup}
      hideUnPlannedPopup={hideUnPlannedPopup}
      ShowUnPlannedPopup={ShowUnPlannedPopup}
      hideGrowthdPopup={hideGrowthdPopup}
      ShowGrowthPopup={ShowGrowthPopup}
      showEditPlannedPopup={showEditPlannedPopup}
      showEditUnPlannedPopup={showEditUnPlannedPopup}
      showEditGrowthPopup={showEditGrowthPopup}
      resetOnclick={resetOnclick}
      resetForm={resetForm}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      isAttachmentBtnClicked={isAttachmentBtnClicked}
      linkAttachmentId={linkAttachmentId}
      setIsAttachmentBtnClicked={setIsAttachmentBtnClicked}
      onLinkAttachmentClosed={onLinkAttachmentClosed}
      onLinkAttachmentClicked={onLinkAttachmentClicked}
      setSelectedAttachments={setSelectedAttachments}
      selectedAttachments={selectedAttachments}
      iconReturn={iconReturn}
      orderDetails={orderDetails}
      Driverlableval={Driverlableval}
      detailslableval={detailslableval}
      onDriverClick={onDriverClick}
      showTooltip={showTooltip}
      setPopupcontent={setPopupcontent}
      getFormattedValue={getFormattedValue}
      isBulkOrder={props.isBulkOrder}
    />
  );
};

export default DriverDetailContainer;
